const today = new Date().toISOString().slice(0, 10);
const yesterday = new Date(Date.now() - 86400000).toISOString().slice(0, 10);

const stockUrl = `https://core-api.barchart.com/v1/historical/get?symbol=AMC.AX&
fields=tradeTime.format(m%2Fd%2Fy)%2CopenPrice%2ChighPrice%2ClowPrice%2ClastPrice
%2CpriceChange%2Cvolume%2CsymbolCode%2CsymbolType&startDate=${yesterday}&endDate=${today}
&type=eod&orderBy=tradeTime&orderDir=desc&meta=field.shortName%2Cfield.type%2Cfield.description&page=1&raw=1`;

export default stockUrl;



// WEBPACK FOOTER //
// ./src/api/stockApi.js